import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getEquipmentMetadata, getWorkoutMetadata } from "api/exercisePlan";
import { useAuthLoading, useAuthStatus } from "./OAuth/AuthContext";

export const MetaContext = createContext();

export const useMeta = () => useContext(MetaContext);

const EMPTY_OPTIONS = {
  workoutsCategories: [],
  difficultiesLevel: [],
  equipmentCategories: [],
};

export const MetaProvider = ({ children }) => {
  const { token } = useAuthStatus();
  const [dynamicOptions, setDynamicOptions] = useState(EMPTY_OPTIONS);
 const { isNavigatingCheckout} = useAuthLoading();
  const fetchDynamicOptions = useCallback(async () => {
        if (isNavigatingCheckout) return;

    try {
      const [workoutMeta, equipmentMeta] = await Promise.all([
        getWorkoutMetadata(),
        getEquipmentMetadata(),
      ]);

      const newDynamicOptions = {
        workoutsCategories: workoutMeta.categories ?? [],
        difficultiesLevel: workoutMeta.difficulties ?? [],
        equipmentCategories: equipmentMeta.categories ?? [],
      };

      setDynamicOptions(newDynamicOptions);
      return newDynamicOptions;
    } catch (error) {
      console.error("Error fetching dynamic options:", error);
      return EMPTY_OPTIONS;
    }
  }, []);

  useEffect(() => {
    if (!token) {
      setDynamicOptions(EMPTY_OPTIONS);
      return;
    }
    fetchDynamicOptions();
  }, [token, fetchDynamicOptions]);

  return (
    <MetaContext.Provider
      value={{ dynamicOptions, setDynamicOptions, fetchDynamicOptions }}
    >
      {children}
    </MetaContext.Provider>
  );
};